import React, { PureComponent } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../Apanel/QueryMe';
import { withRouter } from 'react-router-dom';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	image: dimgurl,
	isuser: false,
	uname: '',
	token: localStorage.token,
};

class BasicUserinfo extends PureComponent {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		if (this.props.usermail) {
			this.getuserinfo(localStorage.token);
		}
	}
	getuserinfo = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			email: this.props.usermail,
		};
		const getuurl = apiurl + 'getbasicinfo';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					this.setState({
						isuser: true,
						uname: response.data.data.name,
					});
				}
			})
			.catch((error) => {});
	};
	render() {
		const { image, noimg, uname } = this.state;

		return (
			<ul className="list-group list-group-flush">
				<li className="list-group-item">
					<b>From: </b>
					{this.state.uname}
				</li>
				<li className="list-group-item">{this.props.usermail}</li>
			</ul>
		);
	}
}

export default withRouter(BasicUserinfo);
